import { ReactNode } from 'react'

import { CustomerLogo } from '@sequencehq/core-components'

import { getLogoSrc } from 'Customer/index'
import { InboxListItemContent } from 'Automations/components'
import { useManualTaskListItemContentToolkit } from 'Automations/nodeDefinitions/hooks/useManualTaskListItemContentToolkit'
import { useQuoteData } from '../hooks/useQuoteData'

type QuoteTaskInput = { quoteId: string }

export const QuoteListItem = ({
  taskId,
  isSelected,
  hideUnreadIndicator,
  onClick,
  description
}: {
  taskId: string
  isSelected: boolean
  hideUnreadIndicator?: boolean
  onClick: (e: React.MouseEvent<HTMLDivElement, MouseEvent>) => void
  description: ReactNode
}) => {
  const { manualTask, isUnread, statusIcon } =
    useManualTaskListItemContentToolkit<QuoteTaskInput>({ taskId })

  const { quote, customer } = useQuoteData(manualTask?.input?.quoteId)

  if (!manualTask || !quote) {
    return <InboxListItemContent.Loading />
  }

  return (
    <InboxListItemContent
      isSelected={isSelected}
      isUnread={hideUnreadIndicator ? undefined : isUnread}
      onClick={onClick}
      title={`${quote.quoteNumber} ${quote.title ?? ''}`}
      description={description}
      createdAt={manualTask.createdAt}
      statusIcon={statusIcon}
      icon={
        <InboxListItemContent.TaskIcon isSelected={isSelected}>
          <CustomerLogo
            src={customer ? getLogoSrc(customer) : undefined}
            size={24}
            fallbackSize={16}
          />
        </InboxListItemContent.TaskIcon>
      }
    />
  )
}
